var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "confirm-table" },
    [
      _c(
        "vxe-table",
        {
          ref: "xTable",
          attrs: {
            border: "",
            resizable: "",
            height: "100%",
            data: _vm.tableData,
            size: "medium",
            align: "center",
            "highlight-hover-row": "",
            "highlight-current-row": "",
            "show-overflow": "",
            "auto-resize": "",
            "keep-source": "",
            stripe: ""
          }
        },
        [
          _c("vxe-table-column", { attrs: { type: "seq", width: "60" } }),
          _c("vxe-table-column", {
            attrs: { field: "PART_ID", title: "物料ID" }
          }),
          _c("vxe-table-column", {
            attrs: { field: "PART_NO", title: "料号" }
          }),
          _c("vxe-table-column", {
            attrs: { field: "NAME", title: "物料名称", width: 250 }
          }),
          _c("vxe-table-column", {
            attrs: { field: "DESCRIPTION", title: "规格" }
          }),
          _c("vxe-table-column", { attrs: { field: "PoUnit", title: "单位" } }),
          _c("vxe-table-column", {
            attrs: { field: "MODIFY_MAN", title: "修改人" }
          }),
          _c("vxe-table-column", {
            attrs: { field: "MODIFY_TIME", title: "修改时间" }
          }),
          _c("vxe-table-column", {
            attrs: {
              title: _vm.$t("as_src.tb_og"),
              align: "center",
              fixed: "right",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  var rowIndex = ref.rowIndex
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.handleDelete(row, rowIndex)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("ManagerRole.delete")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }